import { Player, PlayerState, InputAction } from './player-types';

/**
 * プレイヤーの状態遷移を管理するステートマシン
 */
export class PlayerStateMachine {
    private currentState: PlayerState;
    private readonly getPlayerFn: () => Player;

    constructor(getPlayerFn: () => Player) {
        this.getPlayerFn = getPlayerFn;
        // 初期状態は InactiveState とするが、game-state で設定するためここでは仮置き
        this.currentState = null as unknown as PlayerState;
    }

    /**
     * 現在の状態を取得
     */
    getCurrentState(): PlayerState {
        return this.currentState;
    }

    /**
     * 状態を遷移させる
     */
    transitionTo(nextState: PlayerState): void {
        const player = this.getPlayerFn();
        if (this.currentState) {
            this.currentState.exit(player);
        }
        console.log(`Player transition: ${this.currentState?.name} -> ${nextState.name}`);
        this.currentState = nextState;
        this.currentState.enter(player);

        // Playerオブジェクトのstateプロパティも更新（互換性のため）
        player.state = this.currentState;
    }

    /**
     * 状態ごとの更新処理を実行
     */
    update(dt: number): void {
        const player = this.getPlayerFn();
        this.currentState.update(player, dt);
    }

    /**
     * 状態ごとの入力処理を実行
     */
    handleAction(action: InputAction): void {
        const player = this.getPlayerFn();
        this.currentState.handleAction(player, action);
    }
}
